import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SharedSortService {
  private sortBySubject = new BehaviorSubject<string>('initialValue');
  sortBy$ = this.sortBySubject.asObservable();

  updateSortBy(newSortBy: string) {
    this.sortBySubject.next(newSortBy);
  }
}
